import { VEHICLE_TYPE } from "../../../enums/Enums";

export class CarEntity {
  licensePlate;
  manufacturer;
  nickname;
  color;
  isEVSupported;
  isWheelchairAccess;
  chargingPosition;
  userId;
  currentSiteId;
  vehicleType;
  
  constructor(
    licensePlate = "",
    manufacturer = "",
    nickname = "",
    color = "",
    isEVSupported = false,
    isWheelchairAccess = false,
    chargingPosition = 0,
    userId,
    currentSiteId="",
    vehicleType = VEHICLE_TYPE.CAR,
  ) {
    this.licensePlate = licensePlate;
    this.manufacturer = manufacturer;
    this.nickname = nickname;
    this.color = color;
    this.isEVSupported = isEVSupported;
    this.isWheelchairAccess = isWheelchairAccess;
    this.chargingPosition = chargingPosition;
    this.userId = userId;
    this.currentSiteId = currentSiteId;
    this.vehicleType = vehicleType;
  }
}
